'use strict';

TranslationService.$inject = ['mx.SolutionBuilderAgent.Http', 'mx.shell.Language'];
export default function TranslationService(http, MxLanguage) {
	return {
		get: get,
		updateLocalizationString: updateLocalizationString,
		updateTranslation: updateTranslation,
		getAllLanguages: getAllLanguages,
	};

	function get(id) {
		return http.get('api/localization/' + id);
	}

	function updateLocalizationString(translations) {
		return http.post('api/localization/update', translations);
	}

	function updateTranslation(id, translations) {
		return http.post('api/translation/' + id, translations);
	}

	function getAllLanguages(languageGroup) {
		var languagesPromise = http.get('api/internationalization/AllLanguages?languageGroup=' + languageGroup);

		languagesPromise = languagesPromise.then(function (data) {
			return data.map(function (item) {
				return new MxLanguage({
					id: item.Id,
					title: item.Title,
					code: item.Code,
					lcid: item.LCID,
					parentLcid: item.ParentLCID,
					parentTitle: item.ParentTitle,
					flagUrl: item.FlagImagePath,
					twoLetterCode: item.TwoLetterCode,
					isRightToLeft: item.IsRightToLeft,
					isBaseLanguageInGroup: item.IsBaseLanguageInGroup,
				});
			});
		});

		return languagesPromise;
	}
}
